import { render, staticRenderFns } from "./rename.vue?vue&type=template&id=5ed5ca4c&scoped=true&"
import script from "./rename.vue?vue&type=script&lang=js&"
export * from "./rename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5ca4c",
  null
  
)

export default component.exports